export function loadScript(url, timeout = 30000) {
    return new Promise((resolve, reject) => {
        var script = document.createElement('script');
        var prior = document.getElementsByTagName('script')[0];
        script.async = 1;
        prior.parentNode.insertBefore(script, prior);
        let resolved = false;
        let timeoutVar = setTimeout(() => {
            if (!resolved) {
                reject();
            }
        }, timeout);
        script.onload = script.onreadystatechange = function (_, isAbort) {
            if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
                script.onload = script.onreadystatechange = null;
                script = undefined;
                if (!isAbort) {
                    resolved = true;
                    clearTimeout(timeoutVar);
                    resolve();
                }
            }
        };
        script.src = url;
    });
}
